import {
  CLASSES,
  ANCESTRIES,
  COMMUNITIES,
  LEVEL_1_DOMAIN_CARDS,
} from "./daggerheartSrd2.ts";

export interface SrdArtAsset {
  id: string;
  category: "class" | "subclass" | "ancestry" | "community" | "domain-card" | "equipment";
  name: string;
  path: string;
}

export const DAGGERHEART_ART_MANIFEST: Record<string, SrdArtAsset> = {};

function registerAsset(id: string, category: SrdArtAsset["category"], name: string, filename: string) {
  DAGGERHEART_ART_MANIFEST[id] = {
    id,
    category,
    name,
    path: `public/assets/cards/${filename}`,
  };
}

// 1. Classes (13)
for (const cls of Object.values(CLASSES)) {
  const id = `class-${cls.name.toLowerCase()}`;
  registerAsset(id, "class", cls.name, `${id}.svg`);

  // 2. Subclasses (26)
  for (const sc of cls.subclasses) {
    const scSlug = sc.name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
    const scId = `subclass-${cls.name.toLowerCase()}-${scSlug}`;
    registerAsset(scId, "subclass", `${cls.name} (${sc.name})`, `${scId}.svg`);
  }
}

// 3. Ancestries (24)
for (const anc of Object.values(ANCESTRIES)) {
  const id = `ancestry-${anc.name.toLowerCase()}`;
  registerAsset(id, "ancestry", anc.name, `${id}.svg`);
}

// 4. Communities (15)
for (const com of Object.values(COMMUNITIES)) {
  const id = `community-${com.name.toLowerCase()}`;
  registerAsset(id, "community", com.name, `${id}.svg`);
}

// 5. Level 1 Domain Cards (30)
for (const card of LEVEL_1_DOMAIN_CARDS) {
  const slug = card.name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  const id = `card-${card.domain.toLowerCase()}-${slug}`;
  registerAsset(id, "domain-card", `${card.name} [${card.domain}]`, `${id}.svg`);
}

// 6. Generic Tier 1 Equipment Cards (2)
registerAsset("weapon-tier-1-generic", "equipment", "Tier 1 Weapons", "weapon-tier-1-generic.svg");
registerAsset("armor-tier-1-generic", "equipment", "Tier 1 Armor", "armor-tier-1-generic.svg");

// 7. Additional Character Creator Options (Mixed Ancestry & Starting Potions)
registerAsset("ancestry-mixed", "ancestry", "Mixed Ancestry", "ancestry-mixed.svg");
registerAsset("item-minor-health-potion", "equipment", "Minor Health Potion", "item-minor-health-potion.svg");
registerAsset("item-minor-stamina-potion", "equipment", "Minor Stamina Potion", "item-minor-stamina-potion.svg");

export function getArtAsset(id: string): SrdArtAsset | null {
  return DAGGERHEART_ART_MANIFEST[id] ?? null;
}
